/*eslint-disable */
<template>
  <div class="container-fluid">
    <div class="calendar-page-content p-0">
      <div class="row g-4">
        <div class="col-lg-8">
          <div class="card border-0 shadow-sm rounded-lg">
            <div class="card-header bg-white border-0 p-4">
              <div class="d-lg-none pull-right" style="border-radius: 7px;" variant="outline-primary" size="sm" @click="rightmenuIcon = !rightmenuIcon">
                <i class="ri-menu-line menu_icon_left  fint-size 20px"></i>
              </div>
              <div class="pull-right d-flex align-items-center">
                <b-button v-if="(userData.user_role === 'USERROLE11111' || userData.user_role === 'USERROLE11118')" class="float-right" style="border-radius: 7px;" variant="primary" size="sm" @click="addCalendarAppointment()">Add</b-button>
              </div>

              <div class="d-flex flex-wrap justify-content-between align-items-center gap-3">
                <div class="row align-items-center w-100">
                  <div class="col-12 mb-3" v-if="propOpenedInModal == 'true' && (userData.user_role === 'USERROLE11111' || userData.user_role === 'USERROLE11118')">
                    <h6>Student: {{ displayStudentName }}</h6>
                    <h6>Lead Strategist: {{ displayCounsellorName }}</h6>
                  </div>

                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1" v-if="userData.user_role === 'USERROLE11111'">
                    <select v-model="selectedCounsellorId" class="form-control form-control-sm border-primary" @change="switchCounselor()">
                      <option :value="null">All counsellors</option>
                      <option v-for="(couns, index) in counsellorObjList" :key="'counsellor-' + couns.counsellor_user_id + '-' + index" :value="couns.counsellor_user_id">
                        {{ couns.user_name }}
                      </option>
                    </select>
                  </div>

                  <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1" v-if="userData.user_role === 'USERROLE11111'">
                    <select v-model="selectedStudentId" class="form-control form-control-sm border-primary" @change="spcmCalendarConsoleList()">
                      <option value="null">All Students</option>
                      <option v-for="(student, index) in studentListForSelectedCounselor" :key="index + 1" :value="student.id">
                        {{ student.user_name }}
                      </option>
                    </select>
                  </div>

                  <!-- <div class="col-12 col-sm-4 col-lg-2">
                    <select v-model="selectedCategory" class="form-control form-control-sm border-primary" @change="spcmCalendarConsoleList()">
                      <option :value="null">All Categories</option>
                      <option value="General">General</option>
                      <option v-for="(category, index) in spcmCalendarCategory" :key="'cat-' + index" :value="category.category_name">
                        {{ category.category_name }}
                      </option>
                    </select>
                  </div> -->

                  <div class="col-6 col-sm-3 col-lg-2 mb-1">
                    <b-button class="w-100" style="border-radius: 7px;" variant="primary" size="sm" @click="resetToToday">Today</b-button>
                  </div>
                  <div class="col-6 col-sm-3 col-lg-2 mb-1">
                    <select v-model="viewMonth" class="form-control form-control-sm border-primary" @change="updateCalendarView">
                      <option v-for="month in months" :key="month.value" :value="month.value">{{ month.text }}</option>
                    </select>
                  </div>

                  <div class="col-6 col-sm-3 col-lg-2 mb-1">
                    <select v-model="viewYear" class="form-control form-control-sm border-primary" @change="updateCalendarView">
                      <option v-for="year in years" :key="year.value" :value="year.value">{{ year.text }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body px-4 pb-4">
              <FullCalendarWrapper :key="allEvents.length" ref="calendarRef" :events="filteredCalendarEvents" @dateSelected="handleDateChange" />
            </div>
          </div>
        </div>

        <div class="col-lg-4 right_modal_overlay" v-if="rightmenuIcon || !IS_MOBILE_DEVICE">
          <div class="right_modal_content pt-4">
            <i v-if="IS_MOBILE_DEVICE" @click="rightmenuIcon = false" class="fa fa-times close_right_modal" aria-hidden="true"></i>

            <div class="card border-0 shadow-sm rounded-lg mb-2 box-shadow-none">
              <div class="card-header bg-white border-0 px-4 pb-0">
                <h6 class="fw-bolder mb-0" :class="{ 'today-green': isTodaySelected }">
                  {{ isTodaySelected ? "Today's Meetings" : "Meetings" }}
                </h6>
                <p class="text-primary small mb-0 bold"><b>{{ displayDateLabel }}</b></p>
              </div>
              <div class="card-body px-4 pt-3">
                <div v-if="dateSpecificActivities.length > 0">
                  <div v-for="(task, index) in dateSpecificActivities" :key="'today-' + task.id + '-' + index" class="task-card d-flex mb-3 p-3">
                    <div class="task-indicator" :style="{ backgroundColor: getStatusColor(task.raw.slot_start_ts) }" />
                    <div>
                      <h5 class="twoLineOnly">{{ task.title }}</h5>
                      <span class="badge text-white px-2 py-1 b-block" :style="{ backgroundColor: getCategoryColor(task.category) }">
                        {{ task.category || 'General' }}
                      </span>
                      <small v-if="task.studentName" class="d-block mb-1 fw-bold">
                        <i class="fa fa-user"/>&nbsp;
                        {{ task.studentName }} | {{ task.raw.counsellor_name }}
                      </small>
                      <small class="text-dark fw-bold">
                        <i class="fa fa-clock-o" />&nbsp;
                        {{ task.time ? task.time : 'All Day' }}&nbsp;
                        <a v-if="task.raw.slot_start_ts >= Math.floor(Date.now() / 1000)" @click="goToMeeting(task.raw.calendar_meeting_link)" class="font-size-12 bold cursor-pointer primary-color text-muted">(Join Meeting)</a>
                      </small>

                      <div class="mt-1">
                        <button class="btn p-1 text-primary btn-sm" @click.stop="openEventModal(task)">
                          <i class="fa fa-eye" />
                        </button>
                        <button v-if="userData.user_role === 'USERROLE11118' || userData.user_role === 'USERROLE11111'" class="btn p-1 text-primary btn-sm" @click.stop="openEventModal(task, 'edit')">
                          <i class="fa fa-pen" />
                        </button>
                        <button v-if="userData.user_role === 'USERROLE11118' || userData.user_role === 'USERROLE11111'" class="btn p-1 text-danger btn-sm" @click.stop="showSpcmCalenderDeleteDialog(task)">
                          <i class="fa-solid fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center py-4">
                  <i class="fa fa-calendar-times-o text-muted mb-2 fs-3" />
                  <p class="text-muted small">No meetings scheduled for this date</p>
                </div>
              </div>
            </div>

            <div class="card border-0 shadow-sm rounded-lg monthly-scroll-card box-shadow-none">
              <div class="card-header bg-white border-0 px-4 pb-0">
                <h6 class="fw-bold mb-0">Monthly Overview</h6>
                <p class="text-muted small mb-0 fw-semibold">{{ currentMonthName }} {{ viewYear }}</p>
              </div>

              <div class="card-body px-4 pt-3 scroll-y" style="max-height: 40vh; overflow-y: auto;">
                <div v-if="monthlyFilteredActivities.length > 0">
                  <div v-for="(task, index) in monthlyFilteredActivities" :key="'month-' + task.id + '-' + index" class="task-card d-flex mb-3 p-3">
                    <div class="task-indicator" :style="{ backgroundColor: getStatusColor(task.raw.slot_start_ts) }" />
                    <div class="">
                      <h5 class="twoLineOnly">{{ task.title }}</h5>
                      <span class="badge text-white px-2 py-1 b-block mb-1" :style="{ backgroundColor: getCategoryColor(task.category) }">
                        {{ task.category || 'General' }}
                      </span>
                      <small class="text-primary d-block mb-1 fw-bold"><i class="fa fa-user" /> {{ task.studentName }} | {{ task.raw.counsellor_name }}</small>
                      <small class="text-dark fw-bold d-block"><i class="fa fa-clock-o mr-1" /> {{ task.time ? task.time : 'All Day' }}</small>
                      <small class="text-muted d-block"><i class="fa fa-calendar mr-1" /> {{ formatFullDate(task.start) }}</small>
                      <div class="d-block mt-1">
                        <button class="btn p-1 text-primary btn-sm" @click.stop="openEventModal(task)">
                          <i class="fa fa-eye" />
                        </button>
                        <button v-if="userData.user_role === 'USERROLE11118' || userData.user_role === 'USERROLE11111'" class="btn p-1 text-primary btn-sm" @click.stop="openEventModal(task, 'edit')">
                          <i class="fa fa-pen" />
                        </button>
                        <button v-if="userData.user_role === 'USERROLE11118' || userData.user_role === 'USERROLE11111'" class="btn p-1 text-danger btn-sm" @click.stop="showSpcmCalenderDeleteDialog(task)">
                          <i class="ri-delete-bin-line"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center py-4">
                  <i class="fa fa-calendar-times-o text-muted mb-2 fs-3" />
                  <p class="text-muted small">No meetings scheduled in this month.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal v-model="showModal" hide-footer centered title="Meeting Details" header-class="border-0 pb-0">
        <SpcmActivityDetails :propActivity="selectedTask" @emitCloseSpcmActivityDetails="showModal = false" />
      </b-modal>

      <b-modal v-model="showModelSpcmCalenderEdit" scrollable :title="cvEditModalHeader" size="lg">
        <SpcmCalenderEdit v-if="selectedTask" :propOpenedInModal="true" :propActivity="true" :propSpcmCalenderObj="selectedTask.raw" @emitCloseSpcmCalenderEditModal="closeSpcmCalenderEditModal" />
        <template #modal-footer=""><b-button size="sm" @click="closeSpcmCalenderEditModal()">{{cvbtnModalCancel}}</b-button></template>
      </b-modal>

      <b-modal v-model="showModelSpcmCalenderAdd" scrollable :title="cvAddModalHeader" size="lg">
      <SpcmCalenderAdd
          :propOpenedInModal="true"
          :propUserId="selectedStudentId || propSpcmObj.student_id"
          :propSpcmId="propSpcmObj.spcm_id"
          :propActivity="true"
          @emitCloseSpcmCalenderAddModal="closeSpcmCalenderAddModal"
        />
        <template #modal-footer=""><b-button size="sm" @click="closeSpcmCalenderAddModal()">{{cvbtnModalCancel}}</b-button></template>
      </b-modal>

      <b-modal v-model="showModelSpcmCalenderDelete" size="lg" title="Delete" ok-title="Delete" cancel-title="Cancel">
        <p>{{cvDelMessage}}</p>
        <template #modal-footer="">
          <b-button size="sm" @click="showModelSpcmCalenderDelete = false">{{cvbtnModalCancel}}</b-button>
          <b-button size="sm" variant="primary" @click="spcmCalendarDelete()">{{cvbtnModalDelOk}}</b-button>
        </template>
      </b-modal>

      <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle" solid><div v-html="toastMsg"></div></b-toast>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import { socialvue } from "../config/pluginInit"
import FullCalendarWrapper from "./FullCalendar.vue"
import { SpcmCalenders } from "../FackApi/api/SpcmCalender.js"
import { SpcmCalendarCategorys } from "../FackApi/api/SpcmCalendarCategory.js"
import { SpcmCounsellors } from "../FackApi/api/SpcmCounsellor.js"
import SpcmCalenderAdd from "../../src/views/Gide/SPCM/SpcmCalenderAddV1.vue"
import SpcmCalenderEdit from "../../src/views/Gide/SPCM/SpcmCalenderEditV1.vue"
import SpcmActivityDetails from "./SpcmActivityDetails.vue"

export default {
  name: "SpcmCounselorCalendar",
  components: {
    FullCalendarWrapper,
    SpcmCalenderAdd,
    SpcmCalenderEdit,
    SpcmActivityDetails
  },
  props: {
    propStudentData: {
      type: Object,
      default: null
    },
    propSpcmObj: {
      type: Object,
      default: null
    },
    propOpenedInModal: {
      default: "false"
    }
  },
  data () {
    return {
      selectedDate: moment().format("YYYY-MM-DD"),
      viewMonth: moment().format("MM"),
      viewYear: moment().format("YYYY"),
      selectedCategory: null,
      spcmCalendarCategory: [],
      selectedStudentId: null,
      studentSearch: "",
      showStudentList: false,
      allEvents: [],
      studentListForSelectedCounselor: [],
      counsellorObjList: [],
      cvCounsellorOptions: [],
      showModal: false,
      selectedTask: null,
      selectedCounsellorId: null,
      months: [
        { "value": "01", "text": "January" }, { "value": "02", "text": "February" },
        { "value": "03", "text": "March" }, { "value": "04", "text": "April" },
        { "value": "05", "text": "May" }, { "value": "06", "text": "June" },
        { "value": "07", "text": "July" }, { "value": "08", "text": "August" },
        { "value": "09", "text": "September" }, { "value": "10", "text": "October" },
        { "value": "11", "text": "November" }, { "value": "12", "text": "December" }
      ],
      years: ["2025", "2026", "2027", "2028"].map(y => ({ value: y, text: y })),
      counsellorOptions: [],
      whereFilter: { counsellor_id: null },

      // Modal states
      showModelSpcmCalenderAdd: false,
      showModelSpcmCalenderEdit: false,
      showModelSpcmCalenderDelete: false,
      showToast: false,
      toastMsg: "",
      toastVariant: "success",
      toastTitle: "Appointments",
      cvAddModalHeader: "Add Appointment",
      cvEditModalHeader: "Edit Appointment",
      cvbtnModalCancel: "Close",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure you want to delete this appointment?",
      delObj: null,
      IS_MOBILE_DEVICE: true,
      rightmenuIcon: false }
  },
  computed: {
    /**
     * userData
     */
    userData () {
      return { ...this.$store.getters["User/userData"] }
    },
    /**
     * Dynamically gets the selected student's name
     */
    displayStudentName () {
      // If no student is selected, show "All Students" or the initial prop value
      if (!this.selectedStudentId) return "All Students"
      const student = this.studentListForSelectedCounselor.find(
        s => s.id === this.selectedStudentId
      )
      return student ? student.user_name : this.propSpcmObj.student_name
    },
    /**
     * Dynamically gets the selected counsellor's name
     */
    displayCounsellorName () {
      const counsellor = this.counsellorObjList.find(c => c.counsellor_user_id === this.selectedCounsellorId)
      return counsellor ? counsellor.user_name : this.propSpcmObj.counsellor_name
    },
    /**
     * filteredStudentOptions
     */
    filteredStudentOptions () {
      const search = this.studentSearch.toLowerCase()
      if (!search) return this.studentListForSelectedCounselor
      return this.studentListForSelectedCounselor.filter(s => s.user_name.toLowerCase().includes(search))
    },
    /**
     * filteredCalendarEvents
     */
    filteredCalendarEvents () {
      if (!this.selectedCategory) return this.allEvents
      return this.allEvents.filter(e => e.category === this.selectedCategory)
    },
    /**
     * dateSpecificActivities
     */
    dateSpecificActivities () {
      return this.filteredCalendarEvents.filter(e => e.start === this.selectedDate)
    },
    /**
     * monthlyFilteredActivities
     */
    monthlyFilteredActivities () {
      const prefix = this.viewYear + "-" + this.viewMonth
      return this.filteredCalendarEvents.filter(e => e.start.startsWith(prefix))
        .sort((a, b) => moment(a.start).unix() - moment(b.start).unix())
    },
    /**
     * currentMonthName
     */
    currentMonthName () {
      const obj = this.months.find(m => m.value === this.viewMonth)
      return obj ? obj.text : ""
    },
    /**
     * isTodaySelected
     */
    isTodaySelected () {
      return this.selectedDate === moment().format("YYYY-MM-DD")
    },
    /**
     * displayDateLabel
     */
    displayDateLabel () {
      return moment(this.selectedDate).format("dddd, MMM Do, YYYY")
    }
  },
  created () {
    this.loadData()
  },
  async mounted () {
    socialvue.index()
    if (window.innerWidth > 991) {
      this.IS_MOBILE_DEVICE = false
    }

    if (this.propSpcmObj && this.propSpcmObj.student_id) {
      this.selectedStudentId = this.propSpcmObj.student_id
    }
    else if (this.propStudentData && this.propStudentData.user_id) {
      this.selectedStudentId = this.propStudentData.user_id
    }

    await this.SpcmCalendarCategoryList()

    if (this.userData.user_role != "USERROLE11114") {
      await this.spcmStudentDistinctCounsellorList()
      await this.spcmCounsellorList()
    }

    await this.spcmCalendarConsoleList()

    this.$nextTick(() => {
      if (this.$refs.calendarRef) {
        this.updateCalendarView()
      }
    })
  },
  methods: {
    /**
     * Returns a color code based on whether the timestamp is in the past, today, or future.
     * @param {Number} timestamp - Unix timestamp
     */
    getStatusColor (timestamp) {
      const sessionDate = moment.unix(timestamp).startOf("day")
      const today = moment().startOf("day")

      if (sessionDate.isBefore(today)) {
        return "#ff4d4d" // Past (Red)
      }
      else if (sessionDate.isSame(today)) {
        return "#28a745" // Present/Today (Green)
      }
      else {
        return "#ffa500" // Future (Orange)
      }
    },
    /**
     * Go To Meeting Link
     */
    goToMeeting (url) {
      window.open(url, "_blank")
    },
    /**
     * loadData
     */
    loadData () {
      if (SpcmCalenders && Array.isArray(SpcmCalenders.counsellors)) {
        this.counsellorOptions = SpcmCalenders.counsellors.map(c => ({
          id: c.counsellorId,
          name: c.counsellorName
        }))
      }
      else {
        this.counsellorOptions = []
      }

      let urlId
      if (this.userData && this.userData.user_role === "USERROLE11118") {
        urlId = this.userData.user_id
      }
      else {
        urlId = this.propSpcmObj ? this.propSpcmObj.counsellor_id : null
      }

      this.selectedCounsellorId = urlId || (this.counsellorOptions[0]?.id || null)
      if (this.selectedCounsellorId) {
        this.populateCalendarByCounsellor(this.selectedCounsellorId)
      }
    },
    /**
     * spcm Calendar Console List
     */
    async spcmCalendarConsoleList () {
      if (this.selectedStudentId !== "") {
        this.whereFilter.student_id = this.selectedStudentId
      }
      else {
        // If empty string is selected, remove the student filter entirely
        delete this.whereFilter.student_id
      }

      let resp = await SpcmCalenders.spcmCalendarConsoleList(this, this.whereFilter)
      if (!resp.resp_status) {
        this.allEvents = []
        return
      }

      if (resp.resp_status) {
        this.allEvents = resp.resp_data.data.map(item => {
          const startMoment = moment.unix(item.slot_start_ts)
          const themeColor = this.getCategoryColor(item.category)
          return {
            id: item.spcm_calendar_id,
            title: item.title,
            category: item.category,
            description: item.description,
            start: startMoment.format("YYYY-MM-DD"),
            time: startMoment.format("hh:mm A"),
            backgroundColor: themeColor,
            borderColor: themeColor,
            textColor: "#ffffff",
            color: themeColor,
            studentId: item.student_id,
            studentName: item.student_name,
            raw: item
          }
        })
      }
    },
    /**
     * getCategoryColor
     */
    getCategoryColor (categoryName) {
      if (!categoryName) return "#00cec9" // Default color
      const category = this.spcmCalendarCategory.find(
        cat => cat.category_name.toLowerCase() === categoryName.toLowerCase()
      )

      return category ? category.color_code : "#00cec9"
    },
    /**
     * populateCalendarByCounsellor
     */
    populateCalendarByCounsellor (id) {
      if (!SpcmCalenders || !Array.isArray(SpcmCalenders.counsellors)) return
      const counsellor = SpcmCalenders.counsellors.find(c => c.counsellorId === id)
      if (counsellor) {
        let events = []
        let students = []
        counsellor.students.forEach(stu => {
          students.push({ id: stu.studentId, name: stu.studentName })
          if (stu.events) {
            stu.events.forEach(ev => {
              events.push({
                ...ev,
                studentId: stu.studentId,
                studentName: stu.studentName,
                color: this.getCategoryColor(ev.category)
              })
            })
          }
        })
        this.allEvents = events
        this.studentListForSelectedCounselor = students
      }
    },
    /**
     * switch Counselor
     */
    async switchCounselor () {
      this.whereFilter.counsellor_id = this.selectedCounsellorId
      this.selectedStudentId = this.selectedStudentId
      this.studentSearch = ""
      await this.spcmStudentDistinctCounsellorList()
      await this.spcmCalendarConsoleList()
      this.updateCalendarView()
    },
    /**
     * updateCalendarView
     */
    updateCalendarView () {
      this.$nextTick(() => {
        const targetDate = this.viewYear + "-" + this.viewMonth + "-01"
        if (this.$refs.calendarRef && typeof this.$refs.calendarRef.gotoDate === "function") {
          this.$refs.calendarRef.gotoDate(targetDate)
        }
      })
    },
    /**
     * handleDateChange
     */
    handleDateChange (dateStr) {
      this.selectedDate = dateStr
    },
    /**
     * resetToToday
     */
    resetToToday () {
      this.selectedDate = moment().format("YYYY-MM-DD")
      this.viewMonth = moment().format("MM")
      this.viewYear = moment().format("YYYY")
      this.updateCalendarView()
    },
    /**
     * formatDay
     */
    formatDay (date) { return moment(date).format("DD") },
    /**
     * formatMonthShort
     */
    formatMonthShort (date) { return moment(date).format("MMM") },
    /**
     * formatFullDate
     */
    formatFullDate (date) { return moment(date).format("MMMM Do, YYYY") },
    /**
     * openEventModal
     */
    openEventModal (task, mode = "view") {
      this.selectedTask = task
      if (mode === "edit") this.showModelSpcmCalenderEdit = true
      else this.showModal = true
    },
    /**
     * addCalendarAppointment
     */
    addCalendarAppointment () { this.showModelSpcmCalenderAdd = true },
    /**
     * closeSpcmCalenderAddModal
     */
    closeSpcmCalenderAddModal () {
      this.showModelSpcmCalenderAdd = false
      this.spcmCalendarConsoleList()
    },
    /**
     * closeSpcmCalenderEditModal
     */
    closeSpcmCalenderEditModal () {
      this.showModelSpcmCalenderEdit = false
      this.selectedTask = null
      this.spcmCalendarConsoleList()
    },
    /**
     * showSpcmCalenderDeleteDialog
     */
    showSpcmCalenderDeleteDialog (item) {
      this.delObj = item
      this.showModelSpcmCalenderDelete = true
    },
    /**
     * spcmCalendarDelete
     */
    async spcmCalendarDelete () {
      try {
        if (!this.delObj || !this.delObj.id) return
        let resp = await SpcmCalenders.spcmCalendarDelete(this, this.delObj.id)
        if (resp && resp.resp_status) {
          this.showModelSpcmCalenderDelete = false
          this.toastMsg = "Successfully deleted"
          this.toastVariant = "success"
          this.showToast = true
          await this.spcmCalendarConsoleList()
        }
      }
      catch (err) { console.error("Delete Error:", err) }
    },
    /**
     * SpcmCalendarCategoryList
     */
    async SpcmCalendarCategoryList () {
      let resp = await SpcmCalendarCategorys.SpcmCalendarCategoryList(this)
      if (resp && resp.resp_status) {
        this.spcmCalendarCategory = resp.resp_data.data
      }
    },
    /**
     * spcmCounsellorList
     */
    async spcmCounsellorList () {
      const counsellorsListResp = await SpcmCounsellors.spcmCounsellorList(this)
      if (counsellorsListResp && counsellorsListResp.resp_status) {
        this.counsellorObjList = counsellorsListResp.resp_data.data
      }
    },
    /**
     * Get Students as per the selected counselor
     */
    async spcmStudentDistinctCounsellorList () {
      const filter = { counsellor_id: this.selectedCounsellorId }
      try {
        let resp = await SpcmCalenders.spcmStudentDistinctCounsellorFilterList(this, filter)

        // Correctly navigate the nested response shown in your Network tab
        if (resp && resp.resp_data && resp.resp_data.resp_data && resp.resp_data.resp_data.data) {
          const actualData = resp.resp_data.resp_data.data
          this.studentListForSelectedCounselor = actualData.map(user => ({
            id: user.user_id,
            user_name: user.user_name
          }))
        }
        else {
          this.studentListForSelectedCounselor = []
        }
      }
      catch (err) {
        console.error("spcmStudentDistinctCounsellorList: Error loading student list:", err)
      }
    }
  }
}
</script>

<style scoped>
.student-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1050;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
}
.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
}
.dropdown-item:hover {
  background-color: #f8f9fa;
}
.task-card {
  cursor: pointer;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  padding-left: 20px;
  position: relative;
  transition: transform 0.2s;
}
.task-card:hover {
  transform: translateX(5px);
}
.task-indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  width: 5px;
  border-radius: 8px 0 0 8px;
}
.date-badge {
  min-width: 65px;
  padding: 5px;
  border-radius: 8px;
  line-height: 1.2;
  cursor: pointer;
}
.day-text {
  line-height: 1.1;
}
.month-text {
  font-size: 9px;
  text-transform: uppercase;
}
.scroll-y::-webkit-scrollbar {
  width: 4px;
}
.scroll-y::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 10px;
}
.twoLineOnly {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5em;
  word-break: break-word;
  min-height: unset;
  max-height: 3.4em !important;
}
.card-body >>> .fc {
  min-height: 500px;
}
.today-green {
  color: #28a745 !important;
}
.box-shadow-none {
  box-shadow: none !important;
}

@media screen and (max-width: 991px){
  .right_modal_overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(4px);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
  }
  .right_modal_content {
    position: relative;
    background: #fff;
    width: 100%;
    max-width: 500px;
    border-radius: 12px;
    max-height: 90vh;
    overflow-y: auto;
    padding: 20px 15px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  }
  .close_right_modal {
    float: right;
    font-size: 20px !important;
    position: absolute;
    top: 12px;
    right: 15px;
    color: #555;
    z-index: 100;
  }
}
@media screen and (min-width: 992px){
  .right_modal_overlay {
    display: block;
  }
}
.menu_icon_left{
  border-radius: 7px;
  position: relative;
  left: 20px;
  font-size: 20px;
  top: -9px;
}
</style>
